import "./SignUpForm.css"
import { Button } from "../../../shadcn/components/atoms/buttons"
import { SignUpInputField, SignUpInputFieldProps } from "../SignUpInputField/SignUpInputField"

import { ReactNode } from "react"
import { SignUpSelectField } from "../SignUpSelectField/SignUpSelectField"

interface SignUpFormProps {
	fields: SignUpInputFieldProps[]
	title?: ReactNode
	button?: {
		text: string
		role?: string
		onClick?: (event: any) => void
		disabled?: boolean
		isLoading?: boolean
		name?: string
		type?: "button" | "submit" | "reset"
	}
	accessIdentityButton?: {
		text: string
		role?: string
		onClick?: (event: any) => void
		disabled?: boolean
		isLoading?: boolean
	}
	ssoLoggingIn?: boolean
	name?: string
	onSubmit?: (event: any) => void
}
export function SignUpForm({
	fields,
	button,
	title,
	accessIdentityButton,
	ssoLoggingIn,
	name,
	onSubmit,
}: Readonly<SignUpFormProps>) {
	return (
		<div className="sign-up-form">
			<form {...(name && { name })} onSubmit={onSubmit}>
				{title && <div className="sign-up-form-title">{title}</div>}

				{!ssoLoggingIn && accessIdentityButton && (
					<Button
						loading={accessIdentityButton.isLoading}
						role={accessIdentityButton.role}
						className="sign-up-button w-full"
						variant="outline"
						disabled={accessIdentityButton.disabled}
						onClick={accessIdentityButton.onClick}>
						{accessIdentityButton.text}
					</Button>
				)}

				{!ssoLoggingIn && accessIdentityButton && <div className="or-divider">or</div>}

				{!ssoLoggingIn &&
					fields.map((field) =>
						field.type === "select" ? (
							<SignUpSelectField
								placeholder={field.placeholder}
								key={field.fieldName}
								label={field.label}
								fieldName={field.fieldName}
								options={field.dropdownOptions}
								required={field.required}
								updateField={field.inputFieldHandler}
								selectedItemStyle={field.selectedItemStyle}
							/>
						) : (
							<SignUpInputField
								key={field.fieldName}
								label={field.label}
								type={field.type}
								placeholder={field.placeholder}
								initialValue={field.initialValue}
								inputFieldHandler={field.inputFieldHandler}
								fieldName={field.fieldName}
								required={field.required}
								disabled={field.disabled}
								description={field.description}
								inputMode={field.inputMode}
								autofocus={field.autofocus}
								autocomplete={field.autocomplete}
								passwordAlert={field.passwordAlert}
							/>
						)
					)}
				{!ssoLoggingIn && button && (
					<Button
						loading={button.isLoading}
						role={button.role}
						className="sign-up-button w-full"
						onClick={button.onClick}
						type={button.type}
						disabled={button.disabled}
						{...(button.name && { name: button.name })}>
						{button.text}
					</Button>
				)}
			</form>
		</div>
	)
}
